<template>
  <div class="page" style="margin-left: 200px">
    <el-card class="card" :body-style="{ padding: '20px 20px 0 20px' }">
      <div style="display: flex; justify-content: space-between">
        <div class="header">
          <span
            :class="showView == 1 ? 'showViewClass' : 'viewClass'"
            @click="showView = 1"
            >{{ $t('AirFreight.DataStatistics') }}</span
          >
          <div
            style="
              width: 2px;
              height: 16px;
              margin: 3px 8px;
              background-color: #9c9c9c;
            "
          />
          <span
            :class="showView == 2 ? 'showViewClass' : 'viewClass'"
            @click="showView = 2"
            >{{ $t('AirFreight.BookingQuery') }}</span
          >
        </div>
        <div
          class="mtf1"
          style="display: flex; column-gap: 8px; align-items: center"
        >
          <span>{{ $t('AirFreight.ServiceType') }}:</span>
          <el-select
            v-model="jobType"
            class="elSelect"
            size="small"
            :popper-append-to-body="true"
          >
            <el-option
              v-for="(item, index) in selectList"
              :key="index"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
          <div
            v-if="showView === 2"
            class="scription-center"
            @click="showScription()"
          >
            <i class="el-icon-collection" style="margin-right: 4px"></i
            >{{ $t('AirFreight.SubscriptionCenter') }}
          </div>
        </div>
      </div>
    </el-card>
    <div v-if="showView === 1">
      <data-statistics :job-type.sync="jobType" />
    </div>
    <div v-if="showView === 2">
      <order-search :job-type.sync="jobType" />
    </div>
    <div class="disclaimer">
      <div>
        <p>
          &nbsp;<img
            src="@/assets/fms/disclaimerIcon.svg"
            style="display: inline"
          />&nbsp;{{ $t('SeaFreight.Disclaimer') }}
        </p>
      </div>
    </div>
    <ScriptCenter
      ref="scriptCenter"
      @success="$refs.SubscriptionSuccess.open()"
    />
    <SubscriptionSuccess ref="SubscriptionSuccess" />
  </div>
</template>
<script>
import dataStatistics from './modules/dataStatistics.vue'
import orderSearch from './modules/orderSearch.vue'
import { USER_INFO } from '@/store/mutation-types'
import { ClickMenu } from '@/api/air/order/index'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import i18n from '@/i18n/i18n'
export default {
  components: {
    dataStatistics,
    orderSearch,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {
    return {
      showView: 1,
      /** 线路筛选 */
      jobType: 'AE',
      selectList: [
        { value: 'AE', label: i18n.t('AirFreight.AirFreightExport') },
        { value: 'AI', label: i18n.t('AirFreight.AirFreightImport') }
      ],
      lang: 'zh'
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    }
  },
  mounted() {
    const params = {
      id: 1
    }
    ClickMenu(params)
    this.lang = this.$ls.get('lang');
  },
  methods: {
    showScription() {
      if (this.jobType === 'AE') {
        this.$refs.scriptCenter.open('FMS_AIR_AE')
      }
      else if (this.jobType === 'AI') {
        this.$refs.scriptCenter.open('FMS_AIR_AI')
      }
    }
  }
}
</script>
<style scoped>
.mtf1 {
  float: right;
  margin-top: -1px;
  border-top: #fff;
}
.scription-center {
  border: 1px solid #53a2b6;
  color: #53a2b6;
  height: 30px;
  line-height: 18px;
  border-radius: 4px;
  padding: 4px 16px;
  cursor: pointer;
}
.page >>> .el-card.is-always-shadow {
  box-shadow: initial !important;
}
.page {
  padding: 10px;
  background: #f0f6fb;
  min-width: 1200px;
}
.page .card .header {
  display: flex;
  line-height: 22px;
  font-weight: bold;
  font-size: 18px;
}
.page .card .header .viewClass {
  color: #9c9c9c;
  cursor: pointer;
}
.page .card .header .showViewClass {
  color: #59b9d3;
  cursor: pointer;
}
.elSelect {
  width: 150px;
  margin-left: 10px;
  margin-right: 20px;
  border-radius: 8px;
}
.disclaimer {
  position: fixed;
  left: 210px;
  bottom: 0;
  right: 0;
  background: #f0f6fc;
  color: #8ca2bd;
  opacity: 0.85;
  font-size: 12px;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
</style>
